// Date-range presets for the filter bar. Dates are calendar days in the account time zone (src/design/timeZone.js).
import { accountTimeZone, calendarDay } from '../design/timeZone';

export const DATE_PRESETS = [
  { id: 'today', label: 'Today' },
  { id: 'yesterday', label: 'Yesterday' },
  { id: 'last7', label: 'Last 7 days' },
  { id: 'last30', label: 'Last 30 days' },
  { id: 'mtd', label: 'Month to date' },
  { id: 'lastMonth', label: 'Last month' },
];

export const DEFAULT_PRESET = 'last7';

const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
const DAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

const isoDay = (d) => d.toISOString().slice(0, 10);

export function businessToday(now = new Date(), zone = accountTimeZone()) {
  return new Date(`${calendarDay(now, zone)}T00:00:00Z`);
}

const addDays = (d, n) => new Date(d.getTime() + n * 86400000);

const dayLabel = (d) => `${DAYS[d.getUTCDay()]}, ${MONTHS[d.getUTCMonth()]} ${d.getUTCDate()}, ${d.getUTCFullYear()}`;

const rangeLabel = (from, to) =>
  from.getUTCFullYear() === to.getUTCFullYear()
    ? `${MONTHS[from.getUTCMonth()]} ${from.getUTCDate()} – ${MONTHS[to.getUTCMonth()]} ${to.getUTCDate()}, ${to.getUTCFullYear()}`
    : `${MONTHS[from.getUTCMonth()]} ${from.getUTCDate()}, ${from.getUTCFullYear()} – ${MONTHS[to.getUTCMonth()]} ${to.getUTCDate()}, ${to.getUTCFullYear()}`;

/** Returns { id, label, from, to, rangeLabel } with from/to as inclusive ISO calendar dates. */
export function resolvePreset(id, now = new Date(), zone = accountTimeZone()) {
  const today = businessToday(now, zone);
  const preset = DATE_PRESETS.find((p) => p.id === id) || DATE_PRESETS.find((p) => p.id === DEFAULT_PRESET);
  let from;
  let to = today;
  switch (preset.id) {
    case 'today':
      from = today;
      break;
    case 'yesterday':
      from = addDays(today, -1);
      to = from;
      break;
    case 'last30':
      from = addDays(today, -29);
      break;
    case 'mtd':
      from = new Date(Date.UTC(today.getUTCFullYear(), today.getUTCMonth(), 1));
      break;
    case 'lastMonth':
      from = new Date(Date.UTC(today.getUTCFullYear(), today.getUTCMonth() - 1, 1));
      to = new Date(Date.UTC(today.getUTCFullYear(), today.getUTCMonth(), 0));
      break;
    case 'last7':
    default:
      from = addDays(today, -6);
  }
  const single = isoDay(from) === isoDay(to);
  return { id: preset.id, label: preset.label, from: isoDay(from), to: isoDay(to), rangeLabel: single ? dayLabel(from) : rangeLabel(from, to) };
}
